
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';

export default defineComponent({
  name: 'AppSignOut',
  props: {
    isAnchor: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const isSignedIn = computed(() => store.getters.auth.isSignedIn);

    const signOut = async () => {
      await store.dispatch.auth.signOut();
      await router.push('/sign-in');
    };

    return {
      signOut,
      isSignedIn
    };
  }
});
